import { render, staticRenderFns } from "./form-dlg.vue?vue&type=template&id=58ad0280&scoped=true"
import script from "./form-dlg.vue?vue&type=script&lang=js"
export * from "./form-dlg.vue?vue&type=script&lang=js"
import style0 from "./form-dlg.vue?vue&type=style&index=0&id=58ad0280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad0280",
  null
  
)

export default component.exports